// removed by extract-text-webpack-plugin
module.exports = {"InfoBoard":"InfoBoard__InfoBoard__29M-s","TableHeader":"InfoBoard__TableHeader__32Jy8","Red":"InfoBoard__Red__27l6B","Green":"InfoBoard__Green__nAUnO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/InfoBoard/InfoBoard.css
// module id = 59
// module chunks = 0